export default $axios => resource => ({
    index(params) {
        return $axios.get(`/${resource}`, {params})
    }
})
